import { render, staticRenderFns } from "./PhysicianListAddNew.vue?vue&type=template&id=456de0ea&"
import script from "./PhysicianListAddNew.vue?vue&type=script&lang=js&"
export * from "./PhysicianListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports